import PubSub from "./pubsub.js";

class RefillForm extends HTMLElement {
  constructor() {
    super()
    this.pubsub = PubSub;

    this.submit = this.querySelector("button[type='submit']")
  }

  connectedCallback() {
    this.submit.addEventListener("click", this.handleSubmit.bind(this))
  }
  disconnectedCallback() {
    this.submit.removeEventListener("click", this.handleSubmit.bind(this))
  }

  handleSubmit = (e) => {
    e.preventDefault()

    console.log("TARGET: ", e.target.form)

    const formData = new FormData(e.target.form)

    // console log formdata
    for (const [key, value] of formData.entries()) {
      console.log(key, value)
    }

    // add to cart fetch request
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => {
        if (response.ok) {
          console.log("Added to cart")

        } else {
          console.error("Error adding to cart")
        }
      })
      .catch((error) => {
        console.error("Error:", error)
      })
      .finally(() => {
        this.pubsub.pub('cart:rerender');
        setTimeout(() => {
          this.pubsub.pub('cart:add');
        }, 300);
      });


  }

}

customElements.get("refill-form") || customElements.define("refill-form", RefillForm);